import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { padding } from "polished";
import React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import { Link } from "@brexhq/next/src/components/shared/Link";
import { Video } from "@brexhq/next/src/components/shared/Video/video";
import { Text } from "@brexhq/shared/components/Typography/Text";

import { LeadFormSteps } from "../../machines/types";
import { FinalStateViewTemplate } from "../PageTemplates/FinalStateViewTemplate";

export const SuccessContentContainer = styled(Container)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  flexShrink: 0,
  width: 635,
  textAlign: "center",
  maxWidth: "100%",
  ...padding(0, theme.spacing[32]),
  [theme.breakpoints.phone]: {
    width: "auto",
  },
}));

export const ButtonWrapper = styled.div({
  display: "flex",
  justifyContent: "center",
});

export const Success: React.FC = () => {
  const { colors } = useTheme();

  const successGraphic = (
    <Video
      src="https://brand.brex.com/m/2dbccd07ab48f40b/2C323D44-congratsmotion-whitebg.mp4"
      autoPlay
      loop
      muted
    />
  );

  const successTitle = (
    <Text
      as="h2"
      className="_lr-hide dd-privacy-mask"
      color={colors.content.primary}
      margin={{
        LRG: [0, 0, 24, 0],
        MED: [0, 0, 24, 0],
        SML: [0, 0, 24, 0],
      }}
      components={{
        LRG: "Headline3",
        MED: "Headline3",
        SML: "Headline4",
      }}
    >
      {
        "For a company your size, we can do the heavy lifting. A Brex advisor will be in touch shortly to help you get set up."
      }
    </Text>
  );

  const backToHomeButton = (
    <ButtonWrapper>
      <Link
        margin={[0]}
        component="Story"
        modifier="primary"
        to="/"
        label="Back to home"
      />
    </ButtonWrapper>
  );

  return (
    <FinalStateViewTemplate currentLeadFormStep={LeadFormSteps.success}>
      <SuccessContentContainer>
        {successGraphic}
        {successTitle}
        {backToHomeButton}
      </SuccessContentContainer>
    </FinalStateViewTemplate>
  );
};
